import { render, staticRenderFns } from "./files.vue?vue&type=template&id=3dc7aab4"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=3dc7aab4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc7aab4')) {
      api.createRecord('3dc7aab4', component.options)
    } else {
      api.reload('3dc7aab4', component.options)
    }
    module.hot.accept("./files.vue?vue&type=template&id=3dc7aab4", function () {
      api.rerender('3dc7aab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/files.vue"
export default component.exports